/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Table_Project_NameInputs */

const en_automatic_save_table_project_name = /** @type {(inputs: Automatic_Save_Table_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Name`)
};

const fr_automatic_save_table_project_name = /** @type {(inputs: Automatic_Save_Table_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du projet`)
};

const de_automatic_save_table_project_name = /** @type {(inputs: Automatic_Save_Table_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektname`)
};

const it_automatic_save_table_project_name = /** @type {(inputs: Automatic_Save_Table_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome del progetto`)
};

const ru_automatic_save_table_project_name = /** @type {(inputs: Automatic_Save_Table_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название проекта`)
};

const es_automatic_save_table_project_name = /** @type {(inputs: Automatic_Save_Table_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del proyecto`)
};

const zh_cn2_automatic_save_table_project_name = /** @type {(inputs: Automatic_Save_Table_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目名称`)
};

const ja_automatic_save_table_project_name = /** @type {(inputs: Automatic_Save_Table_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクト名`)
};

const hi_automatic_save_table_project_name = /** @type {(inputs: Automatic_Save_Table_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परियोजना का नाम`)
};

const pt_pt2_automatic_save_table_project_name = /** @type {(inputs: Automatic_Save_Table_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do projeto`)
};

/**
* | output |
* | --- |
* | "Project Name" |
*
* @param {Automatic_Save_Table_Project_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_table_project_name = /** @type {((inputs?: Automatic_Save_Table_Project_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Table_Project_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_save_table_project_name(inputs)
	if (locale === "de") return de_automatic_save_table_project_name(inputs)
	if (locale === "it") return it_automatic_save_table_project_name(inputs)
	if (locale === "ru") return ru_automatic_save_table_project_name(inputs)
	if (locale === "es") return es_automatic_save_table_project_name(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_save_table_project_name(inputs)
	if (locale === "ja") return ja_automatic_save_table_project_name(inputs)
	if (locale === "hi") return hi_automatic_save_table_project_name(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_save_table_project_name(inputs)
	return en_automatic_save_table_project_name(inputs)
});